// @flow
'use strict';

import * as React from 'react';

import type { ITotais } from '../types';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

type TotaisProps = {
  totais : ITotais,
};

export default function Totais({ totais } : TotaisProps) {
  const { totalImpostoSeletivo, totalIbsCbs } = totais || {};
  const { totalIbs, totalCbs, totalMonofasia, totalEstornoCredito } = totalIbsCbs || {};
  return (
      <div className="tab-pane active">
        <h3>Totais ICMS</h3>
        <RowDetalhes data={ totais }>
          <ColumnDetalhes field="valorTotalBcIcms" type="moeda" width="25%">
            Valor Total Base de Cálculo ICMS
          </ColumnDetalhes>
          <ColumnDetalhes field="valorTotalIcms" type="moeda" width="25%">Valor Total ICMS</ColumnDetalhes>
          <ColumnDetalhes field="valorTotalProdutoServico" type="moeda" width="25%">
            Valor Total dos Produtos e Serviços
          </ColumnDetalhes>
          <ColumnDetalhes field="valorTotalFrete" type="moeda" width="25%">Valor Total do Frete</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totais }>
          <ColumnDetalhes field="valorTotalDesconto" type="moeda" width="25%">Valor Total do Desconto</ColumnDetalhes>
          <ColumnDetalhes field="valorTotalPis" type="moeda" width="25%">Valor Total do PIS</ColumnDetalhes>
          <ColumnDetalhes field="valorTotalCofins" type="moeda" width="25%">Valor Total da COFINS</ColumnDetalhes>
          <ColumnDetalhes field="valorTotalNfce" type="moeda" width="25%">Valor Total da NFC-e</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totais }>
          <ColumnDetalhes field="valorAproximadoTotalTributos" type="moeda">
            Valor Aproximado Total de Tributos
          </ColumnDetalhes>
        </RowDetalhes>

        <h3>Total do Imposto Seletivo</h3>
        <RowDetalhes data={ totalImpostoSeletivo }>
          <ColumnDetalhes field="valorImpostoSeletivo" type="moeda">Total do Imposto Seletivo</ColumnDetalhes>
        </RowDetalhes>

        <h3>Totais da NFe com IBS e CBS</h3>
        <RowDetalhes data={ totalIbsCbs }>
          <ColumnDetalhes field="bcIbsCbs" type="moeda">Base de Cálculo (BC) IBS e CBS</ColumnDetalhes>
        </RowDetalhes>

        <h4>Total do IBS</h4>
        <RowDetalhes data={ totalIbs?.totalIbsUF } className="no-margin-bottom">
          <ColumnDetalhes field="valorDiferimento" type="moeda" width="33%">Diferimento da UF</ColumnDetalhes>
          <ColumnDetalhes field="valorDevolucaoTributos" type="moeda" width="33%">Devolução de Trib. da
            UF</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsUF" type="moeda" width="33%">IBS da UF</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalIbs?.totalIbsMunicipio } className="no-margin-bottom">
          <ColumnDetalhes field="valorDiferimento" type="moeda" width="33%">Diferimento do Município</ColumnDetalhes>
          <ColumnDetalhes field="valorDevolucaoTributos" type="moeda" width="33%">Devolução de Trib. do
            Município</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsMunicipio" type="moeda" width="33%">IBS do Município</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalIbs }>
          <ColumnDetalhes field="valorIbs" type="moeda" width="33%">Total IBS</ColumnDetalhes>
          <ColumnDetalhes field="valorCreditoPresumido" type="moeda" width="33%">Total Crédito
            Presumido</ColumnDetalhes>
          <ColumnDetalhes field="valorCreditoPresumidoCondSusp" type="moeda" width="33%">Total Créd. Pres. em Cond.
            Suspensiva</ColumnDetalhes>
        </RowDetalhes>

        <h4>Total da CBS</h4>
        <RowDetalhes data={ totalCbs } className="no-margin-bottom">
          <ColumnDetalhes field="valorDiferimento" type="moeda" width="33%">Diferimento</ColumnDetalhes>
          <ColumnDetalhes field="valorDevolucaoTributos" type="moeda" width="33%">Devolução de Tributos</ColumnDetalhes>
          <ColumnDetalhes field="valorCbs" type="moeda" width="33%">Total da CBS</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalCbs }>
          <ColumnDetalhes field="valorCreditoPresumido" type="moeda" width="33%">Total Crédito
            Presumido</ColumnDetalhes>
          <ColumnDetalhes field="valorCreditoPresumidoCondSusp" type="moeda" width="67%">Total Créd. Pres. em Cond.
            Suspensiva</ColumnDetalhes>
        </RowDetalhes>

        <h4>Total da Monofasia</h4>
        <RowDetalhes data={ totalMonofasia } className="no-margin-bottom">
          <ColumnDetalhes field="valorIbsMono" type="moeda" width="33%">Total IBS Monofásico</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsMonoReten" type="moeda" width="33%">IBS Monofásico Sujeito a
            Retenção</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsMonoRet" type="moeda" width="33%">IBS Monofásico Retido
            Anteriormente</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalMonofasia }>
          <ColumnDetalhes field="valorCbsMono" type="moeda" width="33%">Total CBS Monofásica</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsMonoReten" type="moeda" width="33%">CBS Monofásica Sujeita a
            Retenção</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsMonoRet" type="moeda" width="33%">CBS Monofásica Retida
            Anteriormente</ColumnDetalhes>
        </RowDetalhes>

        <h4>Total do Estorno de Crédito</h4>
        <RowDetalhes data={ totalEstornoCredito }>
          <ColumnDetalhes field="valorIbsEstornado" type="moeda" width="33%">Total IBS Estornado</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsEstornado" type="moeda" width="67%">Total CBS Estornada</ColumnDetalhes>
        </RowDetalhes>

        <h3>Total da NFe com IBS / CBS / IS</h3>
        <RowDetalhes data={ totalIbsCbs }>
          <ColumnDetalhes field="valorTotalNfe" type="moeda" colSpan={ 4 }>Valor Total da NFe com IBS / CBS /
            IS</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}